import React from 'react'
import { FormattedMessage } from 'react-intl'

type Props = {
  className?: string
}

const NotMedicalAdviceDisclaimer = ({ className }: Props) => {
  // Only EN available for behavioural issues article
  const url =
    'https://help.lifesum.com/en/article/support-links-for-behavioural-issues-iseiug/'

  return (
    <p className={className}>
      <small className="type-nano block leading-body text-grey">
        <FormattedMessage
          id="not_medical_advice_disclaimer"
          values={{
            a: (chunks) => (
              <a className="text-AccentBlue" href={url}>
                {chunks}
              </a>
            ),
          }}
        />
      </small>
    </p>
  )
}

export default NotMedicalAdviceDisclaimer
